export default __webpack_public_path__ + "static/media/Bienvenida-Banner-Biwo.a3f048ca.png";